module.exports = __webpack_public_path__ + "static/img/云主机.39877a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/img/product-article/云主机.png
// module id = 654
// module chunks = 1